// File: RevivalOfStruckOffCompanies.jsx
import React from "react";

export default function RevivalOfStruckOffCompanies() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Revival of Struck Off Companies
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in revival of struck-off companies via NCLT.
          </p>
          <p className="text-gray-700">
            Complete NCLT revival process including Form NCLT-9 petition filing, pending compliance rectification, ROC coordination, Section 252 application, and Certificate of Revival issuance for restored corporate status.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: NCLT struck off company revival) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184411/pexels-photo-3184411.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="NCLT struck off company revival process"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for NCLT revival petitions.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Financial statements and audit reports</li>
                <li>Proof of compliance rectification</li>
                <li>Strike-off order and gazette notification</li>
                <li>Board resolution and affidavits</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Litigation and revival expertise ensuring successful NCLT restoration of struck-off companies.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  NCLT Petition Mastery (Form NCLT-9)
                </h3>
                <p className="text-gray-700 text-sm">
                  Expert Form NCLT-9 filing within 20-year limitation period, complete pending filings (AOC-4, MGT-7, INC-20A), late fee payment, ROC coordination, hearing representation, and NCLT order execution ensuring company name restoration in MCA records.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Compliance Rectification Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Full pendency clearance including financial statements, annual returns, statutory registers, director KYC, DSC updates, tax compliance proof, creditor settlements, and Form INC-28 filing post NCLT order guaranteeing revival approval and active status restoration.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Litigation &amp; Tribunal Success
                </h3>
                <p className="text-gray-700 text-sm">
                  Proven NCLT representation demonstrating company functionality at strike-off, immovable property proof, creditor/workman interests, operational justification, penalty waivers, conditional revival terms negotiation, and post-revival compliance calendar ensuring sustained corporate existence.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
